export const set_quests = (state, quests) => (state.quests = quests);
